module.exports = __webpack_public_path__ + "static/media/gal10.b04ec082.jpg";